import { TypographyT6 } from '@picsart/design-system/foundation/typography';

import { FontWeights } from '@picsart/design-system/foundation/fonts';
import { TextSizes } from '@picsart/growth-rc/Title';
import { useTranslator } from '@picsart/rc/services/localization';
import { Text } from '@picsart/design-system/components/Text';
import cls from 'classnames';
import { HorizontalContainer } from '@picsart/design-system/components/HorizontalContainer';
import Image from 'components/Image';
import { ClickableImageWithTextListProps } from './types';
import TitleWithDefaultSize from '../TitleWithDefaultSize';
import useStyles from './styles';

function ClickableImageWithTextList({ className, items }: ClickableImageWithTextListProps) {
  const classes = useStyles();
  const translate = useTranslator();

  return (
    <HorizontalContainer className={classes.wrapper}>
      <div className={cls(classes.root, className)}>
        <TitleWithDefaultSize
          title={{
            text: translate('Learn more about colors'),
            id: 1,
            tag: 'h3',
            size: TextSizes.Auto,
          }}
          className={classes.title}
        />
        <div className={classes.container}>
          <ul className={classes.imgContainer}>
            {items.map(({ image, link }) => (
              <li key={link?.url}>
                <a href={link?.url} className={classes.item} data-pulse-name={link?.text}>
                  <Image className={classes.img} src={image?.src} alt={image?.alt} />
                  <Text size={TypographyT6} weight={FontWeights.semibold}>
                    {translate(link?.text)}
                  </Text>
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </HorizontalContainer>
  );
}

export default ClickableImageWithTextList;
